import { IfHasAnyPermission as UnscopedIfHasAnyPermission } from "common/Grid";

export const statusOptionsProvider = [
  { value: "completed", label: "Completed" },
  { value: "refunded", label: "Refunded" },
  { value: "pending", label: "Pending" },
  { value: "partial refunded", label: "Partial refunded" },
];

export const siteIdOptionProvider = [
  { value: "10000", label: "10000" },
  { value: "10001", label: "10001" },
  { value: "10002", label: "10002" },
  { value: "10003", label: "10003" },
  { value: "10004", label: "10004" },
  { value: "10005", label: "10005" },
  { value: "10006", label: "10006" },
  { value: "10007", label: "10007" },
  { value: "10008", label: "10008" },
  { value: "10009", label: "10009" },
  { value: "10010", label: "10010" },
];

export const daysOptionsProvider = [
  { value: "last 7 days", label: "Last 7 Days" },
  { value: "last 15 days", label: "Last 15 Days" },
  { value: "last 30 days", label: "Last 30 Days" },
];

export const orderingOptionsProvider = [
  { value: "Takeaway", label: "Takeaway" },
  { value: "Dine-in", label: "Dine-in" },
  { value: "Catering", label: "Catering" },
  { value: "Delivery", label: "Delivery" },
  { value: "Room Service", label: "Room Service" }
];

export const paymentOptionsProvider = [
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "roomCharge", label: "Room Service" },
];

export const HOST = process.env.REACT_APP_API_HOST || "";

export const roleOptions = [
  { label: "Sales Person", value: "Sales Person" },
  { label: "Sales Manager", value: "Sales Manager" },
];

export const userRoles = {
  SALES_PERSON: "Sales Person",
  SALES_MANAGER: "Sales Manager",
  ADMIN: "Admin",
};

export const timezoneOptions = [
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Australia/Brisbane", label: "Australia/Brisbane" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo" },
];


export const siteRequestStatus = {
  NOT_REQUESTED: "notRequested",
  SITE_REQUESTED: "siteRequested",
  REJECTED: "rejected",
  GENERATING: "generating",
  APPROVED: "approved",
};

export const SALES_USER_STATUS = {
  ACTIVE: "active",
  DELETED: "deleted",
};

export const STAFF_ROLES = {
  STAFF_USER: "STAFF_USER",
  STAFF_ADMIN: "STAFF_ADMIN",
  STAFF_SUPER_ADMIN: "STAFF_SUPER_ADMIN",
};

export const staffRoleOptions = [
  { label: "Staff User", value: STAFF_ROLES.STAFF_USER },
  { label: "Staff Admin", value: STAFF_ROLES.STAFF_ADMIN },
];

export const SALES_LEAD_STATUS = {
  COLD: "cold",
  WARM: "warm",
  HOT: "hot",
  IN_PROGRESS: "inProgress",
  COMPLETED: "completed",
  CANCELED: "canceled",
};

export const countries = [
  { value: "au", label: "Australia", currency: "AUD" },
  { value: "nz", label: "New Zealand", currency: "NZD" },
  { value: "ja", label: "Japan", currency: "JPY" },
];

export const IfHasAnyPermissions = ({ permissions, children }) => <UnscopedIfHasAnyPermission permissions={permissions} scope={PERMISSION_SCOPE}>{children}</UnscopedIfHasAnyPermission>;

export const PermissionKeys = {
  CREATE_LEAD: "CREATE_LEAD",
  EDIT_ANY_LEAD: "EDIT_ANY_LEAD",
  VIEW_ALL_LEADS: "VIEW_ALL_LEADS",
  REQUEST_DEMO: "REQUEST_DEMO",
  APPROVE_REJECT_DEMO: "APPROVE_REJECT_DEMO",

  REQUEST_LIVE: "REQUEST_LIVE",
  APPROVE_REJECT_LIVE: "APPROVE_REJECT_LIVE",

  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  VIEW_ADMIN_FEE: "VIEW_ADMIN_FEE",

  MANAGE_CONFIGURATIONS: "MANAGE_CONFIGURATIONS",

  VIEW_INQUIRIES: "VIEW_INQUIRIES",
  EDIT_INQUIRIES: "EDIT_INQUIRIES",
  APPROVE_REJECT_INQUIRIES: "APPROVE_REJECT_INQUIRIES",

  VIEW_ORDERS: "VIEW_ORDERS",
  VIEW_INVOICES: "VIEW_INVOICES",
  GENERATE_INVOICE: "GENERATE_INVOICE",

  IMPORT_PRODUCTS: "IMPORT_PRODUCTS",
  MANAGE_SALES_USERS: "MANAGE_SALES_USERS",
  MANAGE_STAFF_USERS: "MANAGE_STAFF_USERS",
  MANAGE_PERMISSIONS: "MANAGE_PERMISSIONS"
};

export const languageCodeOptions = [
    { label: "JA", value: "JA" },
    { label: "ZH", value: "ZH" },
  ];
export const languageKeyOptions = [
    { label: "ja", value: "ja" },
    { label: "ch", value: "ch" },
  ];
export const languageNameOptions = [
    { label: "japanese", value: "japanese" },
    { label: "chinese", value: "chinese" },
  ];

{/* <IfHasAnyPermission permissions={[UserPermissions.CanSeeComparableTitles]}>
  <PageSection title={pageLabels.sections.comparableTitles.title} isOpenedByDefault={true}>
    <ComparableTitle onesheet={lastViewedOnesheet.data} />
  </PageSection>
</IfHasAnyPermission> */}